import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { gql } from 'graphql-request'

import { useGraphQLClient } from '@/hooks/useGraphQLClient'
import useSessionStore from '@/stores/useSessionStore'
import { brand } from '@/utils/brand'

const PAYMENT_METHODS_QUERY = gql`
  query paymentMethods {
    paymentMethods {
      __typename
      ... on BraintreePaymentMethod {
        cardBrand
        displayName
        expirationDate
        id
        last4
      }
    }
  }
`

interface PaymentMethodResponse {
  paymentMethods: PaymentMethod[]
}

export interface PaymentMethod {
  __typename: string
  cardBrand: string
  displayName: string
  expirationDate: string
  id: string
  last4: string
}

export default function usePaymentMethodsApi(): UseQueryResult<PaymentMethod[], Error> {
  // Token is needed for user context on the server; ensure it's loaded
  const authToken = useSessionStore((store) => store.authToken)
  const client = useGraphQLClient()

  const fetchPaymentMethods = async (): Promise<PaymentMethod[]> => {
    const response = await client.request<PaymentMethodResponse>(PAYMENT_METHODS_QUERY)

    // TODO: Implement club billing in the future
    return response.paymentMethods.filter(
      (method) => method.__typename === 'BraintreePaymentMethod',
    )
  }

  return useQuery<PaymentMethod[], Error>({
    queryKey: ['payment-methods', brand.key],
    queryFn: fetchPaymentMethods,
    enabled: !!authToken && !!brand.key,
  })
}
